export default __webpack_public_path__ + "static/media/CSRealCase1.7d1259b7.png";